import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/index.css";

import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Check if the environment is production
const isProduction = import.meta.env.PROD;

if (isProduction) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracesSampleRate: 1.0
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <HelmetProvider>
      {isProduction ? (
        <Sentry.ErrorBoundary
          fallback={({ error, componentStack, resetError }) => (
            <div>
              <h2>Something went wrong.</h2>
              <details style={{ whiteSpace: "pre-wrap" }}>
                {error && error.toString()}
                <br />
                {componentStack}
              </details>
              <button onClick={resetError}>Try to recover</button>
            </div>
          )}
        >
          <App />
        </Sentry.ErrorBoundary>
      ) : (
        <App />
      )}
    </HelmetProvider>
  </React.StrictMode>
);
